export default __webpack_public_path__ + "static/media/logo1.176b0f67.svg";